import { render, staticRenderFns } from "./AddAccountDialog.vue?vue&type=template&id=6cb6c0b0&"
import script from "./AddAccountDialog.vue?vue&type=script&lang=js&"
export * from "./AddAccountDialog.vue?vue&type=script&lang=js&"
import style0 from "./AddAccountDialog.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VCol,VRow})
